import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db, googleProvider } from "../firebase";

/**
 * E-mails com acesso garantido ao painel. Além deles, entra quem tiver
 * `isAdmin: true` em `usuarios/{uid}` — o mesmo campo que o app usa para
 * mostrar o Painel Admin. As Cloud Functions conferem as mesmas regras.
 */
export const ADMIN_EMAILS = ["phelipecurso@gmail.com"];

const AuthContext = createContext(null);

async function verificarAdmin(user) {
  if (ADMIN_EMAILS.includes(user.email)) return true;
  try {
    const snap = await getDoc(doc(db, "usuarios", user.uid));
    return snap.data()?.isAdmin === true;
  } catch {
    return false;
  }
}

export function AuthProvider({ children }) {
  // status: "loading" | "signed-out" | "denied" | "admin"
  const [state, setState] = useState({ status: "loading", user: null });

  useEffect(() => {
    // O signOut de quem não é admin dispara outro evento com user = null;
    // guardamos o e-mail recusado para a tela de login poder avisar.
    let recusado = null;
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState(
          recusado ? { status: "denied", user: null, email: recusado } : { status: "signed-out", user: null },
        );
        recusado = null;
        return;
      }
      if (await verificarAdmin(user)) {
        setState({ status: "admin", user });
      } else {
        recusado = user.email;
        await signOut(auth);
      }
    });
  }, []);

  const value = {
    ...state,
    isAdmin: state.status === "admin",
    login: () => signInWithPopup(auth, googleProvider),
    logout: () => signOut(auth),
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
